import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';
import { BREAKPOINTS } from 'admin/utils/breakpoints';
import { CLASSNAMES } from 'admin/utils/contants';
import { Images } from 'assets/images';

export const MainLayoutWrapper = styled.div`
  display: flex;
  position: relative;

  @media only screen and ${BREAKPOINTS.laptop} {
    flex-direction: column;
  }
`;

export const SampleSpan = styled.span`
  width: ${({ isLabel }) => (isLabel ? '38px' : 'auto')};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.black};
  user-select: ${({ userSelect }) => userSelect && 'none'} !important;

  &.${CLASSNAMES.ACTIVE} {
    color: ${COLORS.green};
  }

  &.${CLASSNAMES.BLOCKED} {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 62px;
    height: 24px;
    background: ${COLORS.red};
    color: ${COLORS.white};
    border-radius: 4px;
  }

  &.${CLASSNAMES.NOT_BLOCKED} {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 62px;
    height: 24px;
    background: ${COLORS.green};
    color: ${COLORS.white};
    border-radius: 4px;
  }

  &.${CLASSNAMES.INACTIVE} {
    color: ${COLORS.red};
  }
`;

export const SampleImage = styled.img``;

export const SampleDiv = styled.div``;

export const SelectWrapper = styled.div`
  position: relative;
  width: ${({ isStatus }) => (isStatus ? '100%' : '80px')};
  height: 32px;

  &::after {
    content: '';
    position: absolute;
    top: ${({ isStatus }) => (isStatus ? '22px' : '14px')};
    width: 10px;
    right: 10px;
    height: 6px;
    background: url(${Images.selectDownArrow});
    pointer-events: none;
  }
`;
